/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ path: NonNullable<unknown> }} Files_No_Files_In_FolderInputs */

const en_files_no_files_in_folder = /** @type {(inputs: Files_No_Files_In_FolderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No files in ${i?.path}`)
};

const es_files_no_files_in_folder = /** @type {(inputs: Files_No_Files_In_FolderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No hay archivos en ${i?.path}`)
};

/**
* | output |
* | --- |
* | "No files in {path}" |
*
* @param {Files_No_Files_In_FolderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_no_files_in_folder = /** @type {((inputs: Files_No_Files_In_FolderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_No_Files_In_FolderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_no_files_in_folder(inputs)
	return en_files_no_files_in_folder(inputs)
});